<template>
  <div class="fullscreen animated fadeIn" v-if="visible">
    <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>
    <div class="text-center loginscreen">

      <h1>Sessão expirada</h1>

      <div style="margin-top: 10px;">
        <div class="m-b-md">
          <img alt="image" class="img-circle circle-border" :src="user.img || '/static/img/profile.jpg'">
        </div>

        <h3>{{ user.name }}</h3>
        <p><small>{{ user.email }}</small></p>

        <p> Por favor, informe novamente sua senha para continuar </p>

        <form class="m-t" role="form">
          <div class="form-group">
            <input type="password" class="form-control" name="Senha" placeholder="Senha"
            v-model="password" v-validate="'required|min:4'" :class="{ invalid: errors.has('Senha') }" >
            <span class="error">{{ errors.first('Senha') }}</span>
          </div>

          <button class="btn btn-success block full-width" @click.prevent="loginBack()"> <i class="fa fa-sign-in"></i> Continuar</button>

          <a class="btn btn-success btn-outline block full-width" @click="logOut()"> <i class="fa fa-sign-out"></i> Sair </a>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

  import { httpService } from '../providers/http-service'
  import { mapGetters, mapActions } from 'vuex'
  import { toast } from '../mixins/toast'
  import { errorMessage } from '../mixins/error-message'
  import Spinner from './layout/Spinner'

  export default {
    mixins: [ toast, errorMessage ],
    components: { Spinner },
    data() {
      return {
        password: '',
        visible: false,
        showSpinner: false
      }
    },
    methods: {
      ...mapActions(['removeLoggedUser', 'setLoggedUser']),
      ...mapGetters(['getLoggedUser']),

      loginBack() {
        this.$validator.validateAll().then((valid) => {
          if(valid) {
            this.showSpinner = true
            httpService.login({ email: this.user.email, password: this.password }).then((res) => {
              const user = res.data
              localStorage.setItem('token', user.token)
              this.setLoggedUser({ id: user.public_key, name: user.name, email: user.email , img: user.image, token: user.token, companies: user.companies })
              this.showSpinner = false
              this.visible = false
              this.show_toast('success', '', 'Sessão renovada')
            }).catch(err => this.showErrorMessage({ err: err }))
          } else {
            this.show_toast('warning', 'Atenção', 'Verifique novamente os campos informados!')
          }
        })
      },

      logOut() {
        this.removeLoggedUser({})
        localStorage.removeItem('token')
        this.$router.push({ path: '/' })
      },

      listener() {
        this.visible = true
      }

    },
    computed: {
      user() {
        return this.getLoggedUser()
      }
    },

    mounted () {
      window.addEventListener('session_expired', this.listener);
    },

    beforeDestroy() {
      window.removeEventListener('session_expired', this.listener);
    }
  }
</script>

<style scoped>
  .fullscreen {
    position:fixed;
    padding:0;
    margin:0;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    background-color: #000000aa;
    z-index: 1000;
  }
  .loginscreen {
    width: 400px;
    height: 645px;
    padding: 15px 30px;
    margin: 150px auto;
    background-color: #f3f3f4;
    border-radius: 4px;
  }
  .loginscreen h1 { margin: 30px 0; }

  div.m-b-md {
    margin: 10px;
    width: 100%;
    height: 200px;
    line-height: 115px;
    text-align: center;
    margin: 0 0 15px 0;
  }

  img.img-circle.circle-border {
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
  }

  button { margin-bottom: 10px; }

</style>



// WEBPACK FOOTER //
// src/components/LoginComponent.vue